import { render } from "./SelecaoUnidade.vue?vue&type=template&id=fbd758a2&scoped=true"
import script from "./SelecaoUnidade.vue?vue&type=script&lang=js"
export * from "./SelecaoUnidade.vue?vue&type=script&lang=js"

import "./SelecaoUnidade.vue?vue&type=style&index=0&id=fbd758a2&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbd758a2"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QTooltip});
